import React from 'react'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'

const TermsAndConditions = () => {
  return (
    <>
        <div className="terms_conditions">
            <Navbar />
            <div className='container3'>
          <div className='box'>
            <h2>Terms & Conditions</h2>

            <div className="all-animation">

              <div className="all-animation1">
                <img src='all-animations/all-animation1.png' className='circle-img' alt='moon' />

              </div>

              <div className="all-animation2">
                <img src='all-animations/all-animation2.svg' className='cross-img' alt='cross' />

              </div>

              <div className="all-animation3">
                <img src='all-animations/all-animation3.svg' className='circle-img' alt='circle' />

              </div>

              <div className="all-animation4">
                <img src='all-animations/all-animation4.svg' className='triangle-img' alt='triangle' />
              </div>

              <div className="all-animation5">
                <img src='all-animations/all-animation5.png' className='design1' alt='zig-zag' />

              </div>

              <div className="all-animation6">
                <img src='all-animations/all-animation6.svg' className='triangle3' alt='triangle' />

              </div>

              <div className="all-animation7">
                <img src='all-animations/all-animation7.svg' className='triangle3' alt='triangle' />

              </div>

              <div className="all-animation8">
                <img src='all-animations/all-animation8.svg' className='triangle3' alt='triangle' />

              </div>


            </div>


          </div>

             </div>

             <div className="container py-5 terms_points">
                <p><b>Welcome to [WhiteHatSeo].</b> These terms and conditions outline the rules and regulations for the use of [WhiteHatSeo] Website, located at [Mohali ].</p>
                <p>By accessing this website, we assume you accept these terms and conditions. Do not continue to use [WhiteHatSeo] if you do not agree to all of the terms and conditions stated on this page.</p>

                <div className="mt-4">
                    <h3 className="text-blue">1. Introduction</h3>
                    <p>The following terminology applies to these Terms and Conditions, Privacy Statement, and Disclaimer Notice, and all Agreements: “Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company’s terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves.</p>
                </div>

                <div className="mt-4">
                    <h3 className="text-blue">2. Cookies</h3>
                    <p>We employ the use of cookies. By accessing [WhiteHatSeo], you agreed to use cookies in agreement with [WhiteHatSeo]'s Privacy Policy.</p>
                </div>

                <div className="mt-4">
                    <h3 className="text-blue">3. License</h3>
                    <p>Unless otherwise stated, [WhiteHatSeo] and/or its licensors own the intellectual property rights for all material on [WhiteHatSeo]. All intellectual property rights are reserved. You may access this from [WhiteHatSeo] for your own personal use subjected to restrictions set in these terms and conditions.
                    </p>
                    <h5>You must not:</h5>
                    <ul className="">
                        <li>Republish material from [WhiteHatSeo]</li>
                        <li>Sell, rent, or sub-license material from [WhiteHatSeo]</li>
                        <li>Reproduce, duplicate, or copy material from [WhiteHatSeo]</li>
                        <li>Redistribute content from [WhiteHatSeo]</li>
                        <li>This Agreement shall begin on the date hereof.</li>
                    </ul>
                </div>

                <div className="mt-4">
                    <h3 className="text-blue">4. User Comments</h3>
                    <p>Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. [WhiteHatSeo] does not filter, edit, publish, or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of [WhiteHatSeo], its agents, and/or affiliates. Comments reflect the views and opinions of the person who posts their views and opinions. To the extent permitted by applicable laws, [WhiteHatSeo] shall not be liable for the Comments or for any liability, damages, or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.</p>
                    <p>[WhiteHatSeo] reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive, or cause breach of these Terms and Conditions.</p>
                    
                    <h5>You warrant and represent that:</h5>
                    <ul>
                        <li>You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;</li>
                        <li>The Comments do not invade any intellectual property right, including without limitation copyright, patent, or trademark of any third party;</li>
                        <li>The Comments do not contain any defamatory, libelous, offensive, indecent, or otherwise unlawful material which is an invasion of privacy;</li>
                        <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.</li>
                        <li>You hereby grant [WhiteHatSeo] a non-exclusive license to use, reproduce, edit, and authorize others to use, reproduce, and edit any of your Comments in any and all forms, formats, or media.</li>
                    </ul>
                </div>

             </div>

             <Footer />

        </div>
    </>
  )
}

export default TermsAndConditions